import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import pclogin from '@/components/computer/PcLogin'
import pchome from '@/components/computer/home'

Vue.use(Router)

let router = new Router({
  routes: [{
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: () => import('@/components/forget')
    }, {
      path: '/login',
      name: 'login',
      component: pclogin,
      meta: {
        type: login
      }
    },
    { 
      path: '/home',
      name: 'home',
      component: pchome,
      children: [{
          path: 'statistic',
          name: 'statistic',
          component: () => import('@/components/computer/chilren/statistic')
        },
        {
          path: 'recharge',
          name: 'recharge',
          component: () => import('@/components/computer/chilren/recharge')
        },
        {
          path: 'officialrecharge',
          name: 'officialrecharge',
          component: () => import('@/components/computer/chilren/officialrecharge')
        },
        {
          path: 'record',
          name: 'record',
          component: () => import('@/components/computer/chilren/record')
        },
        {
          path: 'dailyrank',
          name: 'dailyrank',
          component: () => import('@/components/computer/chilren/dailyrank')
        },
        {
          path: 'auto-top-up',
          name: 'auto-top-up',
          component: () => import('@/components/computer/chilren/autoTopUp')
        }
      ]
    },
  ]
})
router.beforeEach((to, form, next) => {
  if (window.localStorage.getItem("sid")) {
    next()
  } else {
    if (to.path == '/') {
      next()
    } else if (to.name == 'login' || to.name == 'forgot') {
      next()
    } else {
      next('/');
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js